import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Divider, FlatButton, RaisedButton, Card, CardText, Dialog, DatePicker,
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Checkbox, CircularProgress,
} from "material-ui";
import customDateTimeFormat from "../../../helpers/dateFormat";
import DateIcon from "material-ui/svg-icons/action/date-range";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import {
  OpenConfirmacionGuardadoEliminacion, CloseConfirmacionGuardadoEliminacion,
  CambiarVigenciaPrestacionEliminacion, CheckPrestacionesEli, OpenCargarBorrador, ShowDupsMsg
} from "./actions";
import { CloseEliminarPrestacion } from "../GrillaBusquedaPQ/actions";
import { AddPrestacionSolicitud } from "../GrillaSolicitud/actions";
import { ObtenerTipoProfesional } from "../../Global/actions";
import guid from "../../../helpers/guid";
import styles from "./../../styles/styles";

class EliminarPrestacionForm extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerTipoProfesional());
  }

  CloseEliminarPrestacion = () => {
    this.props.dispatch(CloseEliminarPrestacion());
    this.props.dispatch(CambiarVigenciaPrestacionEliminacion(null, null));
  }

  OpenConfirmacionGuardadoEliminacion = () => {
    const finVigencia = this.props.vigenciaPrestacionEliminacion;
    if (!finVigencia) {
      this.props.dispatch(CambiarVigenciaPrestacionEliminacion(
        this.props.vigenciaPrestacionEliminacion,
        "Debe Agregar Valores Fin Vigencia Prestación"
      ));
      return;
    }
    this.props.dispatch(OpenConfirmacionGuardadoEliminacion());
  }

  CloseConfirmacionGuardadoEliminacion = () => {
    this.props.dispatch(CloseConfirmacionGuardadoEliminacion());
  }

  CambiarVigenciaPrestacionEliminacion = (event, date) => {
    /* const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + 15);
    dateMin.setHours(0, 0, 0, 0);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarVigenciaPrestacionEliminacion(
        dateMod,
        `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else { */
    this.props.dispatch(CambiarVigenciaPrestacionEliminacion(date /* dateMod */));
    /* } */
  }

  GuardarEliminacionSolicitud = () => {
    this.props.centrosAtencionPrestacion.filter((p) => p.checked).forEach((prest) => {
      const prestacion = {
        COD_PRESTADOR: this.props.detallePrestacion.codigoPrestacionPrestador,
        GLOSA_CODPRESTADOR: this.props.detallePrestacion.glosaPrestacionPrestador,
        GLOSA_GRUPOPRESTADOR: this.props.detallePrestacion.glosagGupoPrestacionIsapre,
        PROF_CCOD: this.props.detallePrestacion.codigoProfesional,
        VALOR: prest.Valor,
        UNIDAD: prest.Unidad,
        TIPO_ATENCION: this.props.detallePrestacion.tipoAtencion,
        INICIO_VIG: prest.FechaInicio,
        INICIO_VIG_PREV: this.props.detallePrestacion.inicioVigenciaArancelPrev,
        FECHA_FIN_VIG: this.props.vigenciaPrestacionEliminacion,
        TIPO_PRESTACION: this.props.detallePrestacion.grupoPrestacionIsapre,
        GUARISMO: this.props.detallePrestacion.pabellonPrestacion,
        PERTENENCIA_FONASA: "",
        CODIGO_FONASA: this.props.detallePrestacion.codigoFonasa,
        COD_ISAPRE: this.props.detallePrestacion.codigoPrestacionIsapre,
        ITEM_IMED: this.props.detallePrestacion.itemImed || "",
        CENTRO_AT: prest.Descripcion,
        SECUENCIA: prest.Secuencia,
        ARANCEL: prest.DescripcionArancel,
        RUTARANCEL: prest.Rut,
        IDPRESTACION: prest.IdPrestacion,
        OPERACION: "Eliminación",
        COD_OPERACION: "2",
        GUID: guid.new(),
      };

      this.props.CambiosSinGuardar(true);
      this.props.dispatch(AddPrestacionSolicitud(prestacion));
    });
    this.props.dispatch(CloseConfirmacionGuardadoEliminacion());
    this.CloseEliminarPrestacion();
  }

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }

  CheckPrestacionesEli = (checked, idPrestacion, rutArancel, centroAtencion) => {
    this.props.dispatch(CheckPrestacionesEli(checked, idPrestacion, rutArancel, centroAtencion));
  }

  CheckPrestacionesEliTodos = (checked) => {
    this.props.centrosAtencionPrestacion.forEach((prest) => {
      this.props.dispatch(CheckPrestacionesEli(checked, prest.IdPrestacion, prest.Rut, prest.Secuencia));
    });
  }

  /* checkForDups = () => {
    let alreadyExists = []
    let flag = false
    const { isapre, rutInstitucion } = this.props
    const { tipoAtencion, codigoProfesional, codigoPrestacionPrestador } = this.props.detallePrestacion

    for (const p of this.props.centrosAtencionPrestacion) {
      const prest = {
        isapre,
        rutInstitucion,
        Secuencia: p.Secuencia,
        rutArancel: p.Rut,
        tipoAtencion,
        codigoProfesional,
        codigoPrestacionPrestador,
        guarismo: codigoProfesional == "AN" || codigoProfesional == "DP" || codigoProfesional == "AR" ? this.props.pabellonPrestacion : null
      }

      if (!alreadyExists.length) alreadyExists.push(prest)
      else {
        for (const ae of alreadyExists) {
          if (JSON.stringify(ae) === JSON.stringify(prest)) {
            flag = true
            break
          }
        }
      }as

      if (flag) break
      else alreadyExists.push(prest)
    }

    if (flag) this.props.dispatch(ShowDupsMsg("Hemos detectado prestaciones duplicadas. Favor de contactarse con área de Convenios de la Isapre para solicitar una corrección."))
    else this.props.dispatch(ShowDupsMsg(""))
  } */

  componentDidMount() {
    //this.checkForDups()
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    let alreadyExists = []
    const { isapre, rutInstitucion } = this.props
    const { tipoAtencion, codigoProfesional, codigoPrestacionPrestador } = this.props.detallePrestacion
    let esrepetido = false;

    for (const p of this.props.centrosAtencionPrestacion) {
      const prest = {
        isapre,
        rutInstitucion,
        Secuencia: p.Secuencia,
        rutArancel: p.Rut,
        tipoAtencion,
        codigoProfesional,
        codigoPrestacionPrestador,
        //guarismo: codigoProfesional == "AN" || codigoProfesional == "DP" || codigoProfesional == "AR" ? this.props.pabellonPrestacion : null
      }

      if (!alreadyExists.length) alreadyExists.push(prest)
      else {
        for (const ae of alreadyExists) {
          if (JSON.stringify(ae) === JSON.stringify(prest)) {
            esrepetido = true
            break
          }
        }
      }

      if (esrepetido) break
      else alreadyExists.push(prest)
    }

    let glosaTipoProfesional = this.props.detallePrestacion.codigoProfesional;
    if (this.props.tiposProfesionales && this.props.tiposProfesionales.length > 0) {
      glosaTipoProfesional = this.props.tiposProfesionales
        .filter((tp) => tp.Tipo === this.props.detallePrestacion.codigoProfesional)[0].Descripcion;
    }

    const cantPrestSelect = this.props.centrosAtencionPrestacion.filter((p) => p.checked).length;

    const actionsEliminacion = [
      <FlatButton
        label="Aun no estoy listo. Seguir modificando"
        primary
        onClick={this.CloseConfirmacionGuardadoEliminacion}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.GuardarEliminacionSolicitud}
      />,
    ];

    const arbolTipoArancel = [];
    if (this.props.centrosAtencionPrestacion) {
      this.props.centrosAtencionPrestacion.forEach((prest, indexC) => {
        arbolTipoArancel.push((
          <TableRow key={indexC} id={indexC} >
            <TableRowColumn>
              <Checkbox
                key={`checkboxArancelEli_${indexC}`}
                onCheck={(event, checked) => this.CheckPrestacionesEli(checked, prest.IdPrestacion, prest.Rut, prest.Secuencia)}
                checked={prest.checked}
              />
            </TableRowColumn>
            {/* <TableRowColumn>{this.props.detallePrestacion.codigoPrestacionPrestador}</TableRowColumn> */}
            <TableRowColumn style={{ whiteSpace: "normal", wordWrap: "break-word" }} title={prest.DescripcionArancel}>{prest.DescripcionArancel}</TableRowColumn>
            <TableRowColumn style={{ textAlign: "center" }} title={prest.Descripcion}>{prest.Descripcion}</TableRowColumn>
            {/* <TableRowColumn>{prest.DescPrestacion}</TableRowColumn> */}
            <TableRowColumn title={prest.Unidad}>{prest.Unidad}</TableRowColumn>
            <TableRowColumn title={prest.Valor}>{prest.Valor}</TableRowColumn>
            <TableRowColumn title={prest.FechaInicio != null ? new Date(prest.FechaInicio).toLocaleDateString() : "-"}>{prest.FechaInicio != null ? new Date(prest.FechaInicio).toLocaleDateString() : "-"}</TableRowColumn>
            <TableRowColumn title={prest.FechaTermino != null ? new Date(prest.FechaTermino).toLocaleDateString() : "-"}>{prest.FechaTermino != null ? new Date(prest.FechaTermino).toLocaleDateString() : "-"}</TableRowColumn>
          </TableRow>
        ));
      });
    }


    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Eliminar Prestación
                  </div>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Prestación Prestador:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Prestación:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosagGupoPrestacionIsapre}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Atención:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.tipoAtencion == "A" ? "AMBULATORIA" : "HOSPITALARIA"}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Item IMED:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.itemImed}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Profesional:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {glosaTipoProfesional}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Prestación Prestador:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Fin Vigencia:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <div className="container">
                        <div className="row">
                          <DatePicker
                            name="dp_npf_inicioVigencia"
                            id="dp_npf_inicioVigencia"
                            mode="landscape"
                            DateTimeFormat={customDateTimeFormat.cl()}
                            locale="es-CL"
                            firstDayOfWeek={1}
                            minDate={minDate}
                            value={this.props.vigenciaPrestacionEliminacion}
                            errorText={this.props.vigenciaPrestacionEliminacionError}
                            onChange={this.CambiarVigenciaPrestacionEliminacion}
                            underlineStyle={styles.underlineSelectField}
                            style={{ ...styles.datepickerStyle, width: "80%" }}
                            inputStyle={styles.h4}
                          />
                          <DateIcon
                            style={{ float: "right", width: "15%" }}
                            color={banmedicaTheme.palette.accent1Color}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Fonasa Informado por Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoFonasa}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ padding: 0 }}>
                  <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                </div>
              </div>
              {this.props.loadingArbolDetalle ?
                <CircularProgress></CircularProgress>
                :
                <div style={{ overflowX: "auto" }}>
                  <div style={{ overflow: "hidden" }}>
                    <Table
                      key="table_pres"
                      title="Prestaciones"
                      fixedHeader
                      selectable={false}
                      height={this.props.centrosAtencionPrestacion.length > 6 ? "300px" : null}
                    >
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                        <TableRow>
                          <TableRowColumn>
                            <Checkbox
                              key="checkboxArancelEliAll"
                              onCheck={(event, checked) => this.CheckPrestacionesEliTodos(checked)}
                              checked={cantPrestSelect === this.props.centrosAtencionPrestacion.length}
                            />
                          </TableRowColumn>
                          {/* <TableHeaderColumn>Código Prestación</TableHeaderColumn> */}
                          <TableHeaderColumn>Arancel</TableHeaderColumn>
                          <TableHeaderColumn>Centro Atención</TableHeaderColumn>
                          {/* <TableHeaderColumn>Glosa Prestación</TableHeaderColumn> */}
                          <TableHeaderColumn>Unidad</TableHeaderColumn>
                          <TableHeaderColumn>Valor</TableHeaderColumn>
                          <TableHeaderColumn>Inicio Vig</TableHeaderColumn>
                          <TableHeaderColumn>Fin Vig</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        displayRowCheckbox={false}
                        deselectOnClickaway={false}
                      >
                        {arbolTipoArancel}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              }

              {
                esrepetido ?
                  <div className="row">
                    <div className="col-12">
                      <div style={{
                        ...styles.errorBox,
                        float: "right"
                      }}>
                        {
                          `Hemos detectado prestaciones duplicadas. Favor de contactarse con área de Convenios de la Isapre para solicitar una corrección o al siguiente email: ${this.props.isapre == "B" ? "convenios@banmedica.cl" : "convenios@vidatres.cl"}.`
                        }
                      </div>
                    </div>
                  </div>
                  :
                  null
              }

              <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-12" style={{ textAlign: "right" }}>
                  <RaisedButton
                    onClick={this.CloseEliminarPrestacion}
                    label="Cancelar"
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />

                  <RaisedButton
                    disabled={cantPrestSelect <= 0 || esrepetido}
                    onClick={this.OpenConfirmacionGuardadoEliminacion}
                    label="Eliminar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>


          <Dialog
            key="dialogConfimacionEliminacion"
            id="dialogConfimacionEliminacion"
            actions={actionsEliminacion}
            modal
            open={this.props.aceptaGuardadoModalEliminacion}
            style={{ width: "700px", fontSize: "13px" }}
            title={
              <div>
                <div style={{ float: "right" }}>
                  <IconButton onClick={this.ocultarModalBorrador} >
                    <i className="material-icons" style={{ color: "#fff" }}>close</i>
                  </IconButton>
                </div>
              </div>
            }
          >
            Se eliminará{cantPrestSelect === 1 ? "" : "n"} {cantPrestSelect} {cantPrestSelect === 1 ? "prestación" : "prestaciones"} según la combinación de Centros Médicos y Aranceles seleccionados
          </Dialog>
        </div>
      </div>
    );// hola
  }
}

EliminarPrestacionForm.defaultProps = {
  vigenciaPrestacionEliminacion: null,
  vigenciaPrestacionEliminacionError: "",
};

EliminarPrestacionForm.propTypes = {
  dupsMsg: PropTypes.string.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  aceptaGuardadoModalEliminacion: PropTypes.bool.isRequired,
  vigenciaPrestacionEliminacion: PropTypes.instanceOf(Date),
  vigenciaPrestacionEliminacionError: PropTypes.string,
  tiposProfesionales: PropTypes.array.isRequired,
  centrosAtencionPrestacion: PropTypes.array.isRequired,
  detallePrestacion: PropTypes.any.isRequired,
  loadingArbolDetalle: PropTypes.bool.isRequired,
  // token: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dupsMsg: state.eliminarPrestacionForm.dupsMsg,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  aceptaGuardadoModalEliminacion: state.eliminarPrestacionForm.aceptaGuardadoModalEliminacion,
  vigenciaPrestacionEliminacion: state.eliminarPrestacionForm.vigenciaPrestacionEliminacion,
  vigenciaPrestacionEliminacionError: state.eliminarPrestacionForm.vigenciaPrestacionEliminacionError,
  tiposProfesionales: state.global.tiposProfesionales,
  centrosAtencionPrestacion: state.eliminarPrestacionForm.centrosAtencionPrestacion,
  detallePrestacion: {
    codigoPrestacionPrestador: state.eliminarPrestacionForm.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.eliminarPrestacionForm.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.eliminarPrestacionForm.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.eliminarPrestacionForm.detallePrestacion.codigoFonasa,
    grupoPrestacionIsapre: state.eliminarPrestacionForm.detallePrestacion.grupoPrestacionIsapre,
    grupoPrestacionPrestador: state.eliminarPrestacionForm.detallePrestacion.grupoPrestacionPrestador,
    codigoPrestacionIsapre: state.eliminarPrestacionForm.detallePrestacion.codigoPrestacionIsapre,
    glosaPrestacionIsapre: state.eliminarPrestacionForm.detallePrestacion.glosaPrestacionIsapre,
    codigoProfesional: state.eliminarPrestacionForm.detallePrestacion.codigoProfesional,
    montoArancelPrestacion: state.eliminarPrestacionForm.detallePrestacion.montoArancelPrestacion,
    unidadArancelPrestacion: state.eliminarPrestacionForm.detallePrestacion.unidadArancelPrestacion,
    inicioVigenciaArancelPrev: state.eliminarPrestacionForm.detallePrestacion.inicioVigenciaArancelPrev,
    tipoAtencion: state.eliminarPrestacionForm.detallePrestacion.tipoAtencion,
    itemImed: state.eliminarPrestacionForm.detallePrestacion.itemImed,
    glosagGupoPrestacionIsapre: state.eliminarPrestacionForm.detallePrestacion.glosagGupoPrestacionIsapre,
    IdPrestacion: state.eliminarPrestacionForm.detallePrestacion.IdPrestacion,
  },
  loadingArbolDetalle: state.editarPrestacionForm.loadingArbolDetalle,
  ENV: state.global.ENV,
  // token: state.global.token,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(EliminarPrestacionForm);

